module.exports = __webpack_public_path__ + "img/img42.bddd538b.png";